module.exports = __webpack_public_path__ + "static/media/electrodomesticos.a138ecd4.png";